import {Question} from "src/interfaces";
import {JSONValue, ProcessedKBData} from "src/interfaces/assistant";

function stripHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

export function processKBForAssistant(
  questions: Question[],
  selectedLanguages: {code: string}[],
): Record<string, ProcessedKBData[]> {
  const processedData: Record<string, ProcessedKBData[]> = {};

  selectedLanguages.forEach((lang) => {
    processedData[lang.code] = questions.map((question) => ({
      question: question.langs?.[lang.code]?.question || "",
      answer: stripHtml(question.langs?.[lang.code]?.answer || ""),
      views: question.langs?.[lang.code]?.views || 0,
      upvotes: question.langs?.[lang.code]?.upvotes || 0,
      downvotes: question.langs?.[lang.code]?.downvotes || 0,
    }));
  });

  return processedData;
}

export function processFormForAssistant(form: JSONValue, keysToDiscard: string[]): JSONValue {
  const result = {...form};
  keysToDiscard.forEach((key) => {
    delete result[key];
  });
  return result;
}
